import React from 'react';
import ChaptersHeroRo from '../../components/ro/chapters/ChaptersHeroRo';
import ChaptersGridRo from '../../components/ro/chapters/ChaptersGridRo';

const ChaptersPageRo = () => (
  <main>
    <ChaptersHeroRo />
    <ChaptersGridRo />
  </main>
);

export default ChaptersPageRo;